import { render, staticRenderFns } from "./btnAddCardTable.vue?vue&type=template&id=9ddaed84&scoped=true"
import script from "./btnAddCardTable.vue?vue&type=script&lang=js"
export * from "./btnAddCardTable.vue?vue&type=script&lang=js"
import style0 from "./btnAddCardTable.vue?vue&type=style&index=0&id=9ddaed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddaed84",
  null
  
)

export default component.exports